module.exports = __webpack_public_path__ + "img/sp_logo_white.dc7debd5.png";